import React from 'react';

const NeedleIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='m15.07 19.43-1.42-1.41 1.42-1.42 1.41 1.42 1.41-1.42-1.41-1.41 1.41-1.41 1.42 1.41 1.41-1.41-2.83-2.83-7.07 7.07 2.83 2.83 1.42-1.42M7 23.25l3.12-3.11L8 18.02l9.89-9.9 2.13 2.13 1.4-1.42-1.4-1.42L21.42 6l4.25 4.25-1.41 1.4-1.42-1.4-1.42 1.4 2.13 2.13-9.9 9.89-2.12-2.12L7 26.09v-2.84z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default NeedleIcon;
